import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseBankingInfoUpdateTemplates = [
  {
    id: '-103001',
    language: Language.EN,
    subject: 'Change of our bank details',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_BANKING_INFO_UPDATE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: change of bank details regarding the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Please note our bank account has changed. Please take this into account and update your direct debit for future payments.</p>
        <p></p>
        <p>Our new bank details:</p>
        <ul><li>Account number held by {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Remittance information: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        {{#if advancedChargesBankAccount}}
        <p>Bank details for rental charges:</p>
        <ul><li>Account number held by {{getBankAccountHolder advancedChargesBankAccount}}: <strong>{{advancedChargesBankAccount.number}}</strong></li>
        <li>Remittance information: <strong>{{formatPaymentCommunication lease.advancedChargesInvoices.remittanceInformation}}</strong></li>
        </ul>
        {{/if}}
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-103002',
    language: Language.FR,
    subject: 'Changement de nos informations bancaires',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_BANKING_INFO_UPDATE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: changement des informations bancaires relatives au bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Veuillez noter que notre compte bancaire à changé. Nous vous prions de bien vouloir en tenir compte et mettre votre domiciliation bancaire à jour pour les prochains paiements.</p> 
        <p></p>
        <p>Nos nouvelles coordonnées bancaires:</p>
        <ul><li>Numéro de compte au nom de {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Communication: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        {{#if advancedChargesBankAccount}}
        <p>Coordonnées bancaires pour les charges locatives:</p>
        <ul><li>Numéro de compte au nom de {{getBankAccountHolder advancedChargesBankAccount}}: <strong>{{advancedChargesBankAccount.number}}</strong></li>
        <li>Communication: <strong>{{formatPaymentCommunication lease.advancedChargesInvoices.remittanceInformation}}</strong></li>
        </ul>
        {{/if}}
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-103003',
    language: Language.NL,
    subject: 'Wijziging van onze bankgegevens',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_BANKING_INFO_UPDATE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: wijziging van bankgegevens met betrekking tot het huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Gelieve er nota van te nemen dat onze bankrekening veranderd is. Gelieve hiermee rekening te houden en uw automatische afschrijving aan te passen.</p>
        <p></p>
        <p>Onze nieuwe bankgegevens:</p>
        <ul><li>Rekeningnummer bij {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Mededeling: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        {{#if advancedChargesBankAccount}}
        <p>Bankgegevens voor huurlasten:</p>
        <ul><li>Rekeningnummer bij {{getBankAccountHolder advancedChargesBankAccount}}: <strong>{{advancedChargesBankAccount.number}}</strong></li>
        <li>Mededeling: <strong>{{formatPaymentCommunication lease.advancedChargesInvoices.remittanceInformation}}</strong></li>
        </ul>
        {{/if}}
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-103004',
    language: Language.DE,
    subject: 'Änderung unserer Bankdaten',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_BANKING_INFO_UPDATE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Änderung der Bankdaten bezüglich des Mietvertrags in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Bitte beachten Sie, dass sich unser Bankkonto geändert hat. Bitte berücksichtigen Sie dies und aktualisieren Sie Ihre Lastschrift für zukünftige Zahlungen.</p>
        <p></p>
        <p>Unsere neuen Bankdaten:</p>
        <ul><li>Kontonummer bei {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Verwendungszweck: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        {{#if advancedChargesBankAccount}}
        <p>Bankverbindung für Nebenkosten:</p>
        <ul><li>Kontonummer bei {{getBankAccountHolder advancedChargesBankAccount}}: <strong>{{advancedChargesBankAccount.number}}</strong></li>
        <li>Verwendungszweck: <strong>{{formatPaymentCommunication lease.advancedChargesInvoices.remittanceInformation}}</strong></li>
        </ul>
        {{/if}}
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
